export default __webpack_public_path__ + "static/media/logo-zammad-big.6c0b0cf0.png";